import { CircuitBoardIcon, CloudLightningIcon, MonitorCogIcon, NetworkIcon, ShieldCheckIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Substation Fundamentals & Layouts',
    summary: 'Substation types and functions, voltage levels, bus arrangements, bays, single-line diagrams and layout concepts.',
    icon: NetworkIcon,
  },
  {
    number: '2',
    title: 'Primary Equipment',
    summary: 'Power transformers, circuit breakers, disconnectors and earthing switches, instrument transformers (CTs and VTs), surge arresters, capacitor banks and reactors.',
    icon: CircuitBoardIcon,
  },
  {
    number: '3',
    title: 'Protection Principles & Relays',
    summary: 'Faults and protection zones, overcurrent, distance and differential protection, transformer and busbar protection, protective relays and coordination concepts.',
    icon: ShieldCheckIcon,
  },
  {
    number: '4',
    title: 'Grounding, Insulation & Lightning Protection',
    summary: 'Earthing systems, step and touch voltage, soil resistivity, insulation coordination, surge protection and lightning shielding.',
    icon: CloudLightningIcon,
  },
  {
    number: '5',
    title: 'Control, Automation & Digital Substations',
    summary: 'Control and SCADA systems, RTUs and IEDs, communication protocols, IEC 61850, GOOSE and the digital substation.',
    icon: MonitorCogIcon,
  },
  {
    number: '6',
    title: 'Testing, Commissioning & Maintenance',
    summary: 'Equipment and relay testing, commissioning steps, preventive maintenance, condition monitoring and safe work practices.',
    icon: WrenchIcon,
  },
];
